<div class="card-comparator flex">
  <ng-content></ng-content>
</div>
